import { render, staticRenderFns } from "./editIntegralRule.vue?vue&type=template&id=05963017"
import script from "./editIntegralRule.vue?vue&type=script&lang=js"
export * from "./editIntegralRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports